<template>
    <div class="score">
        <QwixxPenaltyButton :id="0" />
        <QwixxPenaltyButton :id="1" />
        <QwixxPenaltyButton :id="2" />
        <QwixxPenaltyButton :id="3" />
        <span class="score-label"><i class="fas fa-grip-lines-vertical"></i></span>
        <span class="score-total total-red">{{ this.$store.getters.score("red") }}</span>
        <span class="score-separator"><i class="fas fa-plus"></i></span>
        <span class="score-total total-yellow">{{ this.$store.getters.score("yellow") }}</span>
        <span class="score-separator"><i class="fas fa-plus"></i></span>
        <span class="score-total total-green">{{ this.$store.getters.score("green") }}</span>
        <span class="score-separator"><i class="fas fa-plus"></i></span>
        <span class="score-total total-blue">{{ this.$store.getters.score("blue") }}</span>
        <span class="score-separator"><i class="fas fa-minus"></i></span>
        <span class="score-total total-penalty">{{ this.$store.getters.penalties * 5 }}</span>
        <span class="score-separator"><i class="fas fa-equals"></i></span>
        <span class="score-total total-sum">{{ this.$store.getters.score() - this.$store.getters.penalties * 5 }}</span>
    </div>
</template>

<script>

import QwixxPenaltyButton from "@/components/QwixxPenaltyButton"

export default {
    name: 'QwixxScore',
    components: {
        QwixxPenaltyButton,
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.score {
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 2fr 1fr 2fr 1fr 2fr 1fr 2fr 1fr 2fr 1fr 2fr 1fr 4fr;
    grid-gap: 1vw;
    grid-auto-rows: 6vw;
    padding: 1vw;
}
.score-label, .score-separator {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4c566a;
}
.score-penalty-button {
    background: #eceff4;
    border: .5vw solid #4c566a;
    color: #4c566a;
    border-radius: 50%;
    font-size: 5vw;
    display: flex;
    align-items: center;
    justify-content: center;
}
.score-penalty-button:focus {
    outline: none;
}
.score-penalty-button:focus::-moz-focus-inner {
   border: 0;
}
.score-penalty-button svg {
    position: absolute;
}
.score-total {
    border-radius: 1vw;
    font-size: 3vw;
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}
.total-red {
    background: #f9b1bf;
    border: .5vw solid var(--color-red);
    color: var(--color-red);
}
.total-yellow {
    background: #fde1b1;
    border: .5vw solid var(--color-yellow);
    color: var(--color-yellow);
}
.total-green {
    background: #aae1c5;
    border: .5vw solid var(--color-green);
    color: var(--color-green);
}
.total-blue {
    background: #acd2ed;
    border: .5vw solid var(--color-blue);
    color: var(--color-blue);
}
.total-penalty {
    background: #eceff4;
    border: .5vw solid #4c566a;
    color: #4c566a;
}
.total-sum {
    background: #eceff4;
    border: .5vw solid #2e3440;
    color: #2e3440;
}
</style>
